import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import styles from '../domainManager/style.scss';
import PortalTextBox from '../../portal/portalTextBox';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';

@inject('translationsStore', 'windowsDomainsStore') @observer
export default class DomainNameCell extends Component {

    handleNameBlured = _ => this.props.windowsDomainsStore.validateDomainName();

    handleNameChanged = e => this.props.windowsDomainsStore.setDomainName(e.target.value);

    render() {

        const { name } = this.props.windowsDomainsStore.getDomainById(this.props.id);
        const { chosenId, chosenName, editDomainProgress } = this.props.windowsDomainsStore;
        const tooltip = this.props.translationsStore.translate('DOMAIN_TOOLTIP');

        return (
            chosenId === this.props.id ?
                <div
                    className={classNames(styles.domainTableColumnEdit)}
                    title={name}
                >
                    <PortalTextBox
                        dataCy={'domain-name-field'}
                        disabled={editDomainProgress}
                        hintText={this.props.translationsStore.translate('NAME')}
                        onBlur={this.handleNameBlured}
                        onChange={this.handleNameChanged}
                        value={chosenName}
                        errorText={this.props.windowsDomainsStore.domainValidationMessage}
                        helpTooltipText={
                            <div>
                                {tooltip.split('.').map(text => <div key={text}>{text}.</div>)}
                            </div>
                        }
                        floatingLabelText={
                            <TextfieldFloatingText
                                title={this.props.translationsStore.translate('NAME')}
                                required={true} />
                        }
                    />
                </div> :
                <div
                    className={classNames(styles.domainTableColumnDisplay)}
                    title={name}
                >
                    {name}
                </div>
        );
    }
}